<template>
  <section>
    <div class="left">
      <h2 v-translate>Poskytovatelé reklam</h2>
    </div>
    <div class="right">
      <div>
        <checkbox-input
            id="ignore_advertisment_settings"
            v-model="entity.ignore_advertisement_settings"
            :disabled="!isEditable"
        >
          <translate class="translate">Zakázat poskytovatele reklam</translate>
        </checkbox-input>

        <checkbox-input
            id="override_advertising_providers"
            v-if="!entity.ignore_advertisement_settings"
            v-model="overrideAdvertisingProviders"
            :disabled="!isEditable"
            @input="onOverrideAdvertisingProviders"
        >
          <translate class="translate">Přetížit nastavení poskytovatelů reklam</translate>
        </checkbox-input>
      </div>

      <SortableCheckboxList
          v-if="!entity.ignore_advertisement_settings && overrideAdvertisingProviders && advertisingProviders.length > 0"
          :items="advertisingProviders"
          v-model="entity.advertising_providers_order"
          :disabled="!isEditable"
          :allow-sorting="true"
          name="advertisingProviders"
      >
      </SortableCheckboxList>
    </div>
  </section>
</template>

<script>

import SortableCheckboxList from "../../../common/SortableCheckboxList.vue";

export default {
  name: "AdvertisingProviders",
  components: { SortableCheckboxList },
  props: {
    entity: Object,
    advertisingProviders: Array,
    isEditable: Boolean,
  },
  data() {
    return {
      overrideAdvertisingProviders: false,
    }
  },
  methods: {
    onOverrideAdvertisingProviders(value) {
      this.entity.advertising_providers_order = value ? this.advertisingProviders.map(p => p.id) : null
    }
  },
  watch: {
    'entity.advertising_providers_order' (newValue) {
      this.overrideAdvertisingProviders = newValue !== null
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/settings/AdvertisingProviders.vue